import React, { SFC } from "react";
import { makeStyles, Container, Card } from "@material-ui/core";
import { useLocation } from "react-router";

import UserOnBoarding from "../../components/Forms/UserOnboarding";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";

const useStyles = makeStyles({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        position: "relative",
        marginBottom: 55,
        marginTop: 80,
        zIndex: 1,
    },
});

interface Props {
    isOnBoarding: boolean,
    setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>,
    step?: number,
}

const Onboarding: SFC<Props> = ({isOnBoarding, setIsOnBoarding}: Props) => {
    const classes = useStyles();
    const { state } = useLocation()

    return (
        <Container className={classes.containerRoot} maxWidth="sm">
            <Card className={classes.cardRoot} style={{paddingBottom: "40px"}}>
                <UserOnBoarding isOnBoarding={isOnBoarding} setIsOnBoarding={setIsOnBoarding} step={state?.step || 0}/>
            </Card>
        </Container>
    );
};

export default Onboarding;
